export const COOKIE_TOOLTIP_CLOSE = 'nlsearch_tooltip_close';